import { useEffect, useState } from "react";

import XMarkIcon from "../../icons/xMark.icon";

interface FormAlertProps {
  successMessage?: string;
  errorMessage?: string;
  persist?: boolean;
  handleReset: () => void;
  btnText?: string;
  btnOnClick?: () => void;
}

export default function FormAlert({
  successMessage,
  errorMessage,
  persist = false,
  handleReset,
  btnText,
  btnOnClick,
}: FormAlertProps) {
  const [message, setMessage] = useState<string | undefined>("");

  useEffect(() => {
    setMessage(successMessage ? successMessage : errorMessage);
  }, [successMessage, errorMessage]);

  useEffect(() => {
    let timer: any;
    if (!persist) {
      timer = setTimeout(() => {
        handleReset();
        setMessage("");
      }, 6000);
    }
    return () => clearTimeout(timer);
  }, [persist, handleReset]);

  if (!message) return null;

  return (
    <div
      className={`${
        successMessage ? "bg-primary/80" : "bg-red-400"
      } text-white transition-all w-2/5 max-w-[300px] fixed right-1 top-48 flex text-sm md:text-lg`}
    >
      <button className="fill-white" onClick={handleReset}>
        <XMarkIcon className="w-6 h-6" />
      </button>
      <p className="p-1">
        {message}{" "}
        <button className="display inline underline" onClick={btnOnClick}>
          {btnText}
        </button>
      </p>
    </div>
  );
}
